/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Load_Project_File_Read_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Project file read failed. {error}" |
*
* @param {Load_Project_File_Read_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_read_failed_toast = /** @type {((inputs: Load_Project_File_Read_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Read_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de lecture du fichier projet. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projektdatei konnte nicht gelesen werden. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Lettura del file di progetto non riuscita. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка чтения файла проекта. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la lectura del archivo del proyecto. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`项目文件读取失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクトファイルの読み取りに失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट फ़ाइल पढ़ने में विफलता। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha na leitura do arquivo do projeto. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Project file read failed. ${i?.error}`)
});